export default __webpack_public_path__ + "static/media/event_exit.09ed950e.svg";